import { Component } from 'react';

class TableCardComponent extends Component {
    render() {
        let { _pageScope, moduleId, ...others } = this.props;
        let { table, editTable } = _pageScope.props;
        const {
            tableType = 'simpleTable',
            cardType = 'big',
            imgSize = 'large',
            fieldConfig = {},
            title,
            subTitle,
            ...otherProps
        } = others;
        const mergedFieldConfig = {
            title,
            subTitle,
            ...fieldConfig,
        };
        let renderTable = tableType === 'simpleTable' ? table : editTable,
            renderCardMethod = cardType === 'big' ? 'createLargeCard' : 'createSmallCard';
        return renderTable[renderCardMethod](moduleId, { imgSize, fieldConfig: mergedFieldConfig, ...otherProps });
    }
}

export default TableCardComponent;